import BannerSlider from './BannerSlider';
import { useHomeSliders } from '../../hooks/useHomeSliders';

type HomeBannerSliderProps = {
  autoPlayMs?: number;
  className?: string;
  minHeight?: string;
};

export default function HomeBannerSlider({
  autoPlayMs = 5500,
  className = '',
  minHeight = 'min-h-[280px] lg:min-h-[340px]',
}: HomeBannerSliderProps) {
  const { slides, loading } = useHomeSliders();

  if (loading) {
    return (
      <div
        className={`animate-pulse rounded-lg bg-neutral-200 ${minHeight} ${className}`}
        aria-hidden
      />
    );
  }

  if (slides.length === 0) {
    return null;
  }

  return (
    <BannerSlider
      slides={slides}
      autoPlayMs={autoPlayMs}
      className={className}
      minHeight={minHeight}
    />
  );
}
